import React from "react"
import NewsItem from "./news-item"
import SiteContext from "../../context/site-context"
import { getPaidNews, getArticles } from "../../lib/call-api"
import Paginator from "../helpers/paginator"

export default function NewsList({
  page = 1,
  listCol = "",
  itemCol,
  itemsLimit,
  pageType,
}) {
  const pathName = typeof window !== "undefined" ? window.location.pathname : ""
  const {
    loadingSetState,
    paginatorState,
    paginatorSetState,
    userState,
    setShowLoader,
  } = React.useContext(SiteContext)
  const [newsState, newsSetState] = React.useState(() => {
    return []
  })
  const [pageContent, setPageContent] = React.useState(() => {
    return { getRequest: null, paginator: { pageUrl: "" } }
  })

  React.useEffect(() => {
    setShowLoader(true)
    if (pageType === "paid-news") {
      setPageContent({
        getRequest: getPaidNews,
        paginator: {
          pageUrl: "cabinet/services/information-services/news",
        },
      })
    } else if (pageType === "articles") {
      setPageContent({
        getRequest: getArticles,
        paginator: {
          pageUrl: "cabinet/services/information-services/articles",
        },
      })
    } else {
      setPageContent({
        getRequest: getPaidNews,
        paginator: { pageUrl: "news" },
      })
    }

    if (pageContent.getRequest) {
      pageContent
        .getRequest(page)
        .then(response => {
          if (
            response !== undefined &&
            response.status === 200 &&
            response.data.results?.length > 0
          ) {
            if (itemsLimit) {
              newsSetState(response.data.results.slice(0, itemsLimit))
            } else {
              newsSetState(response.data.results)
            }

            loadingSetState(prevValues => (
               {...prevValues, newsLoaded: true}
            ))

            paginatorSetState({
              pagesCount: Math.ceil(
                response.data.count / response.data.page_size
              ),
              currentPage: page,
              pageUrl: pageContent.paginator.pageUrl,
            })
          }
        })
        .then(() => setShowLoader(false))
    }
  }, [page, pageContent.getRequest, userState])

  return (
    <div className={"news-section " + listCol}>
      <div className="hidden visible animated fadeIn full-visible">
        <div className="row">
          {newsState === undefined || newsState.length === 0 ? (
            <p>Новостей нет</p>
          ) : (
            [
              newsState.map(item => {
                if (item.public || userState.isSuperuser) {
                  var allowed = true
                } else if (userState.tariffId?.length > 0) {
                  allowed = item.tarifs.some(
                    ({ id }) => userState.tariffId.indexOf(id) >= 0
                  )
                } else {
                  allowed = false
                }

                return (
                  <NewsItem
                    id={item.id}
                    key={pageType + item.id}
                    href={
                      allowed
                        ? !pathName.includes("/cabinet/services")
                          ? "/news-detail/" + item.id
                          : !pathName.includes(
                              "/cabinet/services/information-services/news"
                            )
                          ? "/cabinet/services/information-services/articles-detail/" +
                            item.id
                          : "/cabinet/services/information-services/news-detail/" +
                            item.id
                        : "#"
                    }
                    item={item}
                    itemCol={itemCol}
                    allowed={allowed}
                    loggedIn={!!userState.username} // userState.username ? true : false
                  />
                )
              }),
              pageType === "paid-news" || pageType === "articles" ? (
                <Paginator
                  key={pageType}
                  pagesCount={paginatorState.pagesCount}
                  currentPage={paginatorState.currentPage}
                  url={paginatorState.pageUrl}
                />
              ) : null,
            ]
          )}
        </div>
        <div className="push50" />
      </div>
    </div>
  )
}
